<style>
.atd-theme > div {
    width: 53px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none;*/
    -webkit-appearance: none;
    margin: 0;
}
div.vue-swatches__container:not(.vue-swatches--inline){
    z-index:999;
}
</style>

<style scoped>
a.el-button.el-button--info.pull-right:hover,.el-button--info:focus,.el-button--info:active {
    border-color:#fff;
    background-color:#fff;
    color:#333;
}
.content-wrapper .content {
    padding-top: 95px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.el-select {
    display: block;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-input-group__prepend {
    cursor: pointer;
}

button[disabled=disabled],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
    border-color: rgba(200, 200, 200, 2.3);
}

.m-t-15 {
    margin-top: 15px;
}
.textarea-custom{
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #d8dce5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #5a5e66;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 1;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
</style>
<template>
<!-- <transition name="el-zoom-in-top"> -->
<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title">Create Domains</h3>
            </div>
            <div class="box-body" v-loading=isLoading>
                    <form method="post" v-on:submit.prevent="onSubmit" class="form">
                        <h5>Select Publisher</h5>
                        <p v-if="!domId">Choose publisher from the dropdown or create one by clicking +add publisher</p>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="pubId" placeholder="Select" filterable @change="setPubUid()">
                                    <el-option v-for="pub in publishers" :data-id="pub.uuid" :key="pub.name" :label="pub.name" :value="pub.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3 m-t-7" v-if="!domId">
                                <router-link to="/admin/bidders/create-publisher/" class="el-button--info m-t-15">
                                    <i class="el-icon-plus el-icon-left"></i>
                                    Create Publisher
                                </router-link>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-9">
                                <h5>Line Separated Domain URLs</h5>
                                <div class="el-input el-input-group el-input-group--prepend">
                                    <!-- <div tabindex="0" class="el-input-group__prepend">https://</div> -->
                                    <textarea 
                                        class="textarea-custom" 
                                        placeholder="Enter Domains line-by-line" 
                                        name="domainList" 
                                        id="domain-name-listing"
                                        @change="handleDomainListChange"
                                        style="padding: 15px 15px 0 15px; width:100%;height:100px;border-radius: 4px;border: 1px solid #d8dce5;resize:none"
                                    >
                                    </textarea>
                                </div>
                                <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
                            </div>
                            <div class="col-md-3 m-t-10">
                                <div class="el-input el-input-group el-input-group--prepend">
                                    <el-checkbox v-model="addToCoreDomain" >Add to Yeti Domains</el-checkbox>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <h5>RTC Currency</h5>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="rtcCurrency" clearable="" filterable placeholder="Select RTC Currency">
                                    <!-- <el-option key="" label="Select a DFP" value=""></el-option> -->
                                    <el-option v-for="item in currenciesOptions" :key="item.id" :label="item.code" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <hr/>
                        <div>
                            <div class="row">
                                <div class="col-md-3">Theme Settings:</div>
                                <div class="col-md-4"></div>
                                <div class="col-md-2">
                                <!-- Button type is button to prevent this from submitting the form -->
                                <button type="button" class=" el-button el-button--secondary" @click="theme={}">
                                    Reset
                                </button>

                                </div>
                            </div>
                            <theme :themeData="theme" @themeChange="updateThemeObj"/>
                        </div>
                        <hr/>

                        <div class="clearfix">
                            <button type="submit" class="el-button el-button--success">
                                <i class="el-icon-plus el-icon-left"></i>
                                Create Domains
                            </button>
                        </div>
                    </form>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import axios from 'axios';
import {
    EventBus
} from '../../../event-bus.js';
import theme from './Theme.vue';
export default {
    components:{theme},
    data: () => {
        return {
            domainList:'',
            domId: '',
            name: '',
            publishers: [],
            isSecure: true,
            rtcCurrency:'',
            pubId: '',
            domainCount:'',
            pubUid: '',
            currenciesOptions: [],
            theme:{
                font_size:'',font_family:'',font_color:'',cta_color:'',background_color:''
            },
            isLoading:true,
            addToCoreDomain: false,
        }
    },
    created: function () {
        console.log("Bidder Domain ID: ", this.$route.params.domId);
        axios.all([
                axios.get(BASE_URL + 'bidder/v1/publishers/?limit=1000'),
                axios.get(BASE_URL + 'v1/currencies/')
            ])
            .then(axios.spread((response, currency) => {
                //console.log("response",response);
                this.publishers = response.data.results;
                this.currenciesOptions = currency.data;
                if (this.$route.query.publisher) {
                    for (let i = 0; i < this.publishers.length; i++) {
                        //console.log(this.publishers[i].id);
                        if (this.publishers[i].id == parseInt(this.$route.query.publisher)) {
                            this.pubId = parseInt(this.$route.query.publisher);
                            // this.setPubUid();
                        }
                    }
                }
                this.isLoading=false
            }));

    },
    methods: {
        handleDomainListChange(event){
            let {value} = event.target;
            let currDomainList = value.trim("\n").split('\n');
            this.domainList = currDomainList;
        },
        updateThemeObj(e){
            this.theme = e
        },
        setPubUid() {
            let i = 0;
            for (; i < this.publishers.length; i++)
                if (this.publishers[i].id == this.pubId) {
                    this.pubUid = this.publishers[i].uuid;
                    //console.log(this.pubUid);
                    break;
                }
        },
        onSubmit() {
            if(this.pubId && this.domainList.length){
                for(let index in this.domainList){
                    try { 
                        Boolean(new URL(this.domainList[index])); 
                    } catch(e) { 
                        this.$notify({
                            title: 'Error',
                            message: `invalid URL : ${this.domainList[index]}`,
                            type: 'error'
                        });
                        return false; 
                    }
                }

                let {pubId:publisher,rtcCurrency:currency,theme} = this;
                let {font_size,font_family,font_color,cta_color,background_color} = theme;
                var response = [];
                ["font_size","font_family","font_color","cta_color","background_color"].forEach(type=>{
                    if(!theme[type]){
                        delete theme[type];
                    }
                })

                for(let url of this.domainList){
                    let res = {
                        url,
                        publisher,
                    };
                    if(currency) res.currency = currency;
                    if(font_size || font_family || font_color || cta_color || background_color) res.theme = theme;
                    response.push(res)
                }

                axios.post(BASE_URL +`bidder/v1/bulk-domains/?add_to_core=${this.addToCoreDomain}`,response).then(response => {
                    this.$notify({
                        title: 'Success',
                        message: 'Successfully created the domains',
                        type: 'success'
                    });
                    EventBus.$emit('update_logs', {});

                    setTimeout(() => {
                        this.$router.push('/admin/bidders/');
                    }, 1000);
                })
                .catch(error => {
                    let tempErr;
                    if(error.response){
                        let {data} = error.response;
                        tempErr = data[0].hasOwnProperty('url') && data[0].url[0];
                    }
                    console.error(error)
                    this.$notify({
                        title: 'Warning',
                        message: tempErr || 'Unable to create the domains',
                        type: 'warning'
                    });
                })
            } else {
                this.$notify({
                    title: 'Error',
                    message: 'Domains or publisher empty',
                    type: 'error'
                });
            }
        }
    },
    computed: {
        formValid() {
            return this.name && this.pubId;
        }
    }
};
</script>



// WEBPACK FOOTER //
// BulkDomain.vue?409c0bb6